'use client';

import { useAuthContext } from '@/contexts/auth';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function MyProfilePage() {
	const router = useRouter();
	const { isGuest } = useAuthContext();

	useEffect(() => {
		if (!isGuest) {
			router.push('/my_profile/centre');
		} else {
			router.push('/my_profile/login');
		}
	}, [router, isGuest]);

	return null;
}
